import { ObjectUtil } from "@mcleod/core";
import { ComponentPropDefinitions, ComponentPropDefinitionUtil } from "../base/ComponentProps";
import { PropType } from "../base/PropType";

export interface BusyMixinProps {
    busy: boolean;
    busyWhenDataSourceBusy: boolean;
}

export class BusyMixinPropDefinitions {
    private static busyMixinProps: ComponentPropDefinitions;

    public static getDefinitions(): ComponentPropDefinitions {
        if (BusyMixinPropDefinitions.busyMixinProps == null) {
            BusyMixinPropDefinitions.busyMixinProps = {
                busy: {
                    type: PropType.bool,
                    defaultValue: false,
                    visibleInDesigner: false,
                    description: "A component that is busy typically is disabled and/or displays a rotating spinner icon to the user."
                },
                busyWhenDataSourceBusy: {
                    type: PropType.bool,
                    category: "Data",
                    defaultValue: false,
                    visibleInMcLeodTailor: true,
                    description: "This toggles whether or not the component will automatically be set to busy when its bound datasource is busy."
                },
            };
            ComponentPropDefinitionUtil.populateComponentPropNames(BusyMixinPropDefinitions.busyMixinProps);
        }
        return ObjectUtil.deepCopy(BusyMixinPropDefinitions.busyMixinProps);
    }
}
